export const MainConfig = {
    AppDetails: {
        app_name: "Etar", 
        app_description: "E-tar is the best cab booking application in your city",
        app_identifier: "com.etar.taxiapp",
        ios_app_version: "1.0.0", 
        android_app_version: 100
    },
    FirebaseConfig: {
        apiKey: "AIzaSyAWAFCStLtZTH_E2ZnJItL0UArOZcBVigs",
  authDomain: "etar-334807.firebaseapp.com",
  databaseURL: "https://etar-334807-default-rtdb.firebaseio.com/",
  projectId: "etar-334807",
  storageBucket: "etar-334807.appspot.com",
  messagingSenderId: "268173142853",
  appId: "1:268173142853:web:0b5b6e2c1f3f4ebc43ac2c",
  measurementId: "G-T1DBSFLDBN"
    },
    Google_Map_API_Key: {
        ios: "AIzaSyAWAFCStLtZTH_E2ZnJItL0UArOZcBVigs",
        android: "AIzaSyAWAFCStLtZTH_E2ZnJItL0UArOZcBVigs",
        web: "AIzaSyAWAFCStLtZTH_E2ZnJItL0UArOZcBVigs"
    },
    facebookAppId: "1027018464710631",
    PurchaseDetails: {
        CodeCanyon_Purchase_Code: "6151684-53135-354354-651566",
        Buyer_Email_Address: "raunixtech@gmail.com"
    }
}